import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H3 } from 'components/common/headers';
import StackContainer from 'components/common/containers/stack_container';

const NavUl = styled.ul`
  margin: 0;
  padding: 0;
`;

/**
 * @visibleName Nav Menu
 */
const NavMenu = ({ children, className = '', dataAid = 'navMenu', title }) => {
  return (
    <nav data-aid={dataAid} className={className} aria-labelledby="nav-menu-label">
      <NavUl role="navigation">
        <StackContainer as="li" stack="medium" inset="none">
          <NavMenuLabel id="nav-menu-label">{title}</NavMenuLabel>
        </StackContainer>
        {children}
      </NavUl>
    </nav>
  );
};

NavMenu.propTypes = {
  /** Child components of the nav menu, usually categories and page links */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /** String of CSS class names to allow custom styling */
  className: PropTypes.string,
  /** String to specify a data-aid for testing */
  dataAid: PropTypes.string,
  /** The title to display for the nav component */
  title: PropTypes.string.isRequired,
};

const NavMenuLabel = styled(H3)`
  margin: 0;
`;

export { NavMenu };



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/nav/nav_menu.jsx